export enum WebSocketConnectionState {
  DISCONNECTED,
  CONNECTING,
  CONNECTED,
}
